import { ITaskRecurrenceRule } from '@common/interfaces/task'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../../helpers/redux'
import { IAction } from '../../apiMiddleware'
import * as actions from './actions'

export interface ITaskRecurrenceRuleListData {
  data: ITaskRecurrenceRule[]
  total: number
}

export default combineReducers({
  // Rules are never listed standalone (they're read via the task's embedded
  // `recurrenceRule`); this slice only tracks the create/update/delete `isSaving`
  // flag the recurrence modal reads — hence no loading triggers.
  list: createLoadingDataReducer<ITaskRecurrenceRuleListData>(
    [],
    [
      actions.CREATE_RECURRENCE_RULE_REQUEST,
      actions.UPDATE_RECURRENCE_RULE_REQUEST,
      actions.DELETE_RECURRENCE_RULE_REQUEST,
    ],
    true,
  ),

  selected(state: ITaskRecurrenceRule | null = null, action: IAction): ITaskRecurrenceRule | null {
    switch (action.type) {
      case actions.GET_RECURRENCE_RULE_SUCCESS:
        return action.data as ITaskRecurrenceRule
      case actions.UPDATE_RECURRENCE_RULE_SUCCESS: {
        const updated = action.data as ITaskRecurrenceRule | undefined
        if (state && updated?.id === state.id) return { ...state, ...updated }
        return state
      }
      case actions.CLEAR_SELECTED_RECURRENCE_RULE:
      case actions.DELETE_RECURRENCE_RULE_SUCCESS:
        return null
      default:
        return state
    }
  },
})
